import { shade } from 'polished'
import styled from 'styled-components'

export const UploaderStyled = styled.div`
  width: 100%;
  position: relative;
  display: block;

  border: 1px dashed ${(props) => shade(0.1, props.theme.colors.lightGrey)};

  > input[type='file'] {
    opacity: 0;
    position: absolute;
    height: 0;
  }
`
